export const tramoComip = {
    paraguay:[
    {
        headline:"Agua y Saneamiento I",
        img:"/images/3_El Tramo COMIP/Paraguay_1_Agua y Saneamiento I.jpeg",
        references:[
            {
            text:"El 91.4 % de las viviendas censadas no cuentan con red de alcantarillado sanitario (cloaca). El desagüe se realiza mayormente por medio de pozo ciego y letrina."
        },
    ]
    },
    {
        headline:"Agua y Saneamiento II",
        img:"/images/3_El Tramo COMIP/Paraguay_2_Agua y Saneamiento II.jpeg",
        references:[
            {
            text:"El 53% de las viviendas censadas cuenta con red de abastecimiento de agua potable. El 47% restante se abastece principalmente con agua subterránea (pozo, aljibe, manantial) y, en menor medida, con agua superficial (río, arroyo, estanque) y otros medios como aguatero móvil."
        },
    ]
    },
    {
        headline:"Población",
        img:"/images/3_El Tramo COMIP/Paraguay_3_Poblacion.jpeg",
        references:[
            {
            text:"Son cuatro los departamentos ubicados en la zona de influencia. El 86% de la población se concentra en los departamentos Alto Paraná e Itapúa."
        },
            {
            text:"<p>Población por distrito &gt;&gt; Tramo Trifinio – Confluencia. <a href='https://files.comip.org.ar/TramoComip/pdf-distritos-2.pdf'>CLICK AQUÍ</a>. Tres distritos fueron creados en el departamento Alto Paraná en el período 2003-2012: <a href='https://files.comip.org.ar/TramoComip/SANTA-FE-DEL-PARANA_L.pdf'>Santa Fé del Paraná</a>, Dr. Raúl Peña y <a href='https://files.comip.org.ar/TramoComip/TAVAPY_.pdf'>Tavapy.</a></p>"
        },
            {
            text:'<p>Fuente: censo 2012, Revisión 2015. Dirección de Estadísticas, Encuestas y Censos (DGEEC), República del Paraguay. Cobertura, <a href="https://files.comip.org.ar/TramoComip/Atlas-Demografico-del-Paraguay-2012.pdf">CLICK AQUÍ.</a></p>'
        },
    ]
    },
    {
        headline:"Población Específica",
        img:"/images/3_El Tramo COMIP/Paraguay_4_Poblacion Especifica.jpeg",
        references:[
            {
            text:'<p>Comunidades por distrito, y departamento. <a href="https://files.comip.org.ar/TramoComip/Pueblos_originarios_py.pdf">CLICK AQUÍ</a>.<br>Fuente: Instituto Paraguayo del Indígena (INDI).</p>'
        },
            
    ]
    },
    {
        headline:"Áreas Silvestres Protegidas - SINASAP",
        img:"/images/3_El Tramo COMIP/Paraguay_5_Areas Silvestres Protegidas - SINASIP.jpeg",
        references:[
            {
            text:'<p>Fuente: Secretaría del Ambiente (SEAM), actual <a href="https://files.comip.org.ar/TramoComip/archivos_8411_Ley-61232018.pdf">Ministerio del Ambiente y Desarrollo Sostenible.</a></p>'
        },
            
    ]
    },
    {
        headline:"División Política",
        img:"/images/3_El Tramo COMIP/Paraguay_6_Division Politica.jpeg",
        references:[
            {
            text:"La República del Paraguay está comprendida entre los paralelos 19°18′ y 27°3′ latitud sur, y los meridianos 54°15′ y 62°38′ longitud oeste."
        },
            {
            text:'<p>Sus límites<br>Norte: limita con el Estado Plurinacional de Bolivia y la República Federativa del Brasil.<br>Sur: limita con la República Argentina.<br>Este: limita con la República Federativa del Brasil y la República Argentina.<br>Oeste: limita con el Estado Plurinacional de Bolivia y la República Argentina.</p>'
        },
            {
            text:'<p>Política y administrativamente está divido en 17 departamentos, y un Distrito Capital, Asunción. Se reconocen dos regiones separadas por el río Paraguay, la Región Oriental y la Región Occidental, con 14 y 3 departamentos respectivamente. Éstos se subdividen en distritos &gt;&gt; 254 distritos totales.</p>'
        },
            {
            text:'<p>Superficie total: 406.752 km2.</p>'
        },
    ]
    },
],
    argentina:[
    {
        headline:"Población",
        img:"/images/3_El Tramo COMIP/Argentina_1_Poblacion.jpeg",
        references:[
            {
            text:'<p>Fuente: censo 2010. Instituto Nacional de Estadísticas y Censos (INDEC), República Argentina.</p>'
        },
    ]
    },
    {
        headline:"Población Específica",
        img:"/images/3_El Tramo COMIP/Argentina_2_Poblacion Especifica.jpeg",
        references:[
            {
            text:'<p>Comunidades por departamento, y por provincia. <a href="https://files.comip.org.ar/TramoComip/Tabla_Pueblos-Originarios_.jpeg">CLICK AQUÍ.</a><br>Fuente: Instituto Nacional de Asuntos Indígenas (INAI), República Argentina.</p>'
        },
    ]
    },
    {
        headline:"Áreas Protegidas",
        img:"/images/3_El Tramo COMIP/Argentina_3_Areas Protegidas.jpeg",
        references:[
            {
            text:'<p>Referencias. <a href="https://files.comip.org.ar/TramoComip/anp_corrientes_misiones.pdf">CLICK AQUÍ.</a></p><p>CORRIENTES &gt;&gt; Reserva Provincial Iberá (1) y Parque Provincial Iberá (2): modificación del dominio y jurisdicción por <a href="https://files.comip.org.ar/TramoComip/Ley-6384-2016-_-Corrientes.pdf">Ley Provincial N°6384/16</a> y <a href="https://files.comip.org.ar/TramoComip/PARQUES-Y-RESERVAS-NACIONALES-LEY-27481-2018.pdf">Ley Nacional N° 27.481/18</a> ( límites establecidos en <a href="https://files.comip.org.ar/TramoComip/Anexos-I-II-II-Ley-27481.pdf">Anexos I, II y III</a> ), sujeto a la <a href="https://files.comip.org.ar/TramoComip/LEY-22351-Parques_Monumentos-y-Reservas-Nacionales.pdf">Ley Nacional N° 22.351/80.</a></p>'
        },
    ]
    },
    {
        headline:"Reservas Ícticas",
        img:"/images/3_El Tramo COMIP/Argentina_4_Reservas Icticas.jpeg",
        references:[
            {
            text:'<p>Reserva Íctica “Caraguatay”. Año de creación: 1979. <a href="https://files.comip.org.ar/TramoComip/LEY-XVI-N-8-Ley-de-Pesca.pdf">CLICK AQUÍ</a>.<br>Ubicación: departamento Montecarlo. Área comprendida entre la desembocadura del arroyo Paranay Guazú hasta el extremo norte de la Isla Caraguatay.<br>Jurisdicción Provincial.</p>'
        },
            {
            text:'<p>Reserva Íctica “Corpus”. Año de creación: 1979. <a href="https://files.comip.org.ar/TramoComip/LEY-XVI-N-8-Ley-de-Pesca.pdf">CLICK AQUÍ.</a><br>Ubicación: departamento San Ignacio. Área comprendida entre las desembocaduras de los arroyos Santo Pipó y Curupaytí.<br>Jurisdicción Provincial.</p>'
        },
            {
            text:'<p>Reserva Íctica “Posadas”. Año de creación: 1979. <a href="https://files.comip.org.ar/TramoComip/LEY-XVI-N-8-Ley-de-Pesca.pdf">CLICK AQUÍ.</a><br>Ubicación: departamento Capital. Área comprendida entre las desembocaduras de los arroyos Garupá e Itaembé.<br>Jurisdicción Provincial.</p>'
        },
        {
            text:'<p>Reserva Íctica intangible – zona presa Yacyretá. <a href="https://files.comip.org.ar/TramoComip/1992_-Ministerio-de-RElaciones-Exteriores.pdf">CLICK AQUÍ</a>.<br>Instrumento legal: Nota Reversal, 1992. Acuerdo entre Argentina y Paraguay para la prohibición absoluta de la pesca en la zona de reserva.<br>Ubicación: 3 kilómetros aguas arriba y 3 kilómetros aguas abajo del eje de la obra de Yacyretá.</p>'
        },
        {
            text:'<p>Reserva Íctica – Corrientes. Año de creación: 1994. <a href="https://files.comip.org.ar/TramoComip/Establece-zonas-de-reserva-fauna-ictica-aguas-territoriales-prohibiciones-puertos-de-carga-y-descarga-pesca-comercial-zonas-autorizadas-pesca-comercial-plazo-veda..pdf">CLICK AQUÍ</a>.<br>Ubicación: Río Paraná y sus afluentes, aguas territoriales de la provincia de Corrientes.<br>Jurisdicción Provincial.</p>'
        }
    ]
    },
    {
        headline:"División Política",
        img:"/images/3_El Tramo COMIP/Argentina_5_Division Politica.jpeg",
        references:[
            {
            text:'<p>La República Argentina está comprendida entre los paralelos 21°46′ y 55°03′ de latitud sur, y los meridianos 50°01′ y 53°38′ longitud oeste. La Antártida Argentina es la parte del territorio nacional comprendida entre los meridianos de 25º y 74º de longitud oeste, el paralelo de 60º sur, y los 90º sur (Polo Sur).</p>'
        },
            {
            text:'<p>Sus límites (parte continental americana)<br>Norte: limita con el Estado Plurinacional de Bolivia y la República del Paraguay.<br>Sur: limita con la República de Chile y el Océano Atlántico Sur.<br>Este: limita con la República Federativa del Brasil, República Oriental del Uruguay y el Océano Atlántico Sur.<br>Oeste: limita con la República de Chile.</p>'
        },
            {
            text:'<p>Política y administrativamente está dividida en 23 Estados Federados (provincias), y una Capital Federal, la Ciudad Autónoma de Buenos Aires (CABA). Éstas se subdividen en departamentos &gt;&gt; 528 departamentos totales (considerando las comunas de la CABA).</p>'
        },
            {
            text:'<p>Superficie total: 3.761.274 km².<br>&gt;&gt; 2.791.810 km² corresponden al Continente Americano (incluyendo las Islas Malvinas).<br>&gt;&gt; 969.464 km² corresponden al Continente Antártico (incluyendo las islas Orcadas del Sur) y a las islas australes (Georgias del Sur y Sandwich del Sur).</p>'
        },
    ]
    },
    
],
}